"use client";

import { useContext } from "react";
import type { WebSocketContextValue } from "./WebSocketContext";
import { WebSocketContext } from "./WebSocketContext";

/**
 * Hook to access WebSocket functionality
 *
 * Provides access to WebSocket connection and message subscription
 *
 * @returns WebSocket context value with connection status and methods
 * @throws Error if used outside WebSocketProvider
 */
export function useWebSocket() {
  const context = useContext(WebSocketContext);
  if (context === undefined) {
    throw new Error("useWebSocket must be used within a WebSocketProvider");
  }
  return context;
}